import { calc16to9ImageProps, POST_PREVIEW_IMAGE_WIDTH } from '../../lib/images';
import Grid from '../common/grid';
import List from '../common/list';
import Image from 'next/legacy/image';
import { img16to9Loader } from '../../lib/images';
import { Video } from '../common/video';

export const EpisodeCard = ({
  item,
  className = '',
  preload = false,
}) => {
  const image = item.episode_image;
  const props = calc16to9ImageProps(image, POST_PREVIEW_IMAGE_WIDTH);

  return (
    <div className={`preview-item preview-item-max-w-none ${className}`}>
      <div className={`relative flex h-full bg-white text-center`}>
        <div className='flex h-full flex-col justify-between overflow-hidden overflow-ellipsis'>
          <div className='rounded-lg-img rounded-lg'>
            
            {item.episode_youtube_url ? 
              <Video video={item.episode_youtube_url} image={image} className='' /> 
              : <Image loader={img16to9Loader} priority={preload} {...props} />
            }
          </div>

          <div className='border-b border-0.3 pt-6'></div>

          <div className='flex flex-1 flex-col p-6 text-center'>
            <div className='mb-3 text-base font-bold uppercase text-black'>
              {item.episode_title}
            </div>
            <p className='mb-6 text-sm text-black'>{item.episode_description}</p>
            <div className='mt-auto text-xs font-semibold uppercase text-black'>
              {item.episode_release_date}
            </div>
          </div>
        </div>
        <div className='preview-item-border'></div>
      </div>
    </div>
  );
};


export const EpisodesSlice = ({ fields }) => {
  return (
    <List component={EpisodeCard} className='mt-6 lg:mt-10 md:mx-6 episodes-slice' items={fields}  Wrapper={Grid} />  
  );
};
